import React from "react";
import bgWelcomeImage from "../../assets/images/bgwelcome.png";
import logo from "../../assets/images/adidas-logo.png";
import SpecificButton from '../specificButton/SpecificButton';


function AdidasHome({ handleClick }) {
    return <div className="h-full md:max-w-[460px] mx-auto  w-full items-center flex flex-col  text-center">

        <img src={bgWelcomeImage} alt="Welcome" className="h-full max-h-[100vh] object-cover fixed w-full  border-none md:max-w-[460px]" />
        <div className="w-full h-full  md:max-w-[460px] flex flex-col justify-end text-center p-4 relative z-10">
            <div className="text-left p-4">
                <div className="mb-3 font-bold text-[26px] leading-[1.2] uppercase">welcome to the <br /> future of Size & Fit <br /> adidas pilot</div>
                <div className="flex justify-between items-end">
                    <div className=" leading-[1.2] uppercase tracking-[2px] text-[10px] mt-6 font-bold">
                        INNOVATION LAB
                        <div className="font-normal text-[10px] mt-1">SEPT. 11-12</div>
                        <img src={logo} alt="Adidas Logo" className="mt-2 h-[30px]" />
                    </div>
                    <div className="max-w-[150px] flex mt-4 ">
                        <SpecificButton btnSecondary buttonFunc={handleClick} buttonText="Start" altroute="" alttxt="" />
                    </div>
                </div>

            </div>
        </div>
    </div>
}

export default AdidasHome